import { IProfilePictureDTO, IUpdateProfilePictureRequestDTO } from 'src/api/dtos';
import http from 'src/api/http';
import CommonRepository from 'src/api/repositories/common/common.repository';
import { IQueryResult } from 'src/api/types';
import { ProfilePictureTypeEnums } from 'src/shared/enums';
import { getFileNameFromAxiosHeader } from 'src/shared/utils';

export default class UserPicturesRepository extends CommonRepository {
  private static readonly baseRoute = '/userpictures';
  private static readonly apiURL = this.setBaseUrl(this.baseURL, this.baseRoute);

  public download = async (
    profilePictureType: ProfilePictureTypeEnums = ProfilePictureTypeEnums.ProfilePicture,
  ): Promise<{ stream: Blob; fileName?: string }> => {
    try {
      const { data, headers } = await http.get(UserPicturesRepository.apiURL, {
        responseType: 'blob',
        params: { profilePictureType },
      });

      return {
        stream: data,
        fileName: getFileNameFromAxiosHeader(headers),
      };
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public getPicture = async (
    profilePictureType: ProfilePictureTypeEnums = ProfilePictureTypeEnums.ProfilePicture,
  ): Promise<IProfilePictureDTO> => {
    try {
      const { data } = await http.get(UserPicturesRepository.apiURL, {
        params: { profilePictureType },
      });
      return data.item;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public upload = async (payload: FormData): Promise<IProfilePictureDTO> => {
    try {
      const { data } = await http.post<IQueryResult<IProfilePictureDTO>>(UserPicturesRepository.apiURL, payload, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });

      return data.item;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public update = async (payload: IUpdateProfilePictureRequestDTO): Promise<IProfilePictureDTO> => {
    try {
      const { data } = await http.patch<IQueryResult<IProfilePictureDTO>>(UserPicturesRepository.apiURL, {
        profilePictureType: ProfilePictureTypeEnums.ProfilePicture,
        ...payload,
      });

      return data.item;
    } catch (e) {
      return Promise.reject(e);
    }
  };

  public delete = async (
    profilePictureType: ProfilePictureTypeEnums = ProfilePictureTypeEnums.ProfilePicture,
  ): Promise<void> => {
    try {
      await http.delete<IQueryResult<IProfilePictureDTO>>(UserPicturesRepository.apiURL, {
        params: { profilePictureType },
      });
    } catch (e) {
      return Promise.reject(e);
    }
  };
}
